'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('../common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('../common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('../common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'Sign Documents Electronically SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'Sign Documents Electronically',
            subtitle: 'It’s easy to get started signing electronically! Create a free HelloSign account to send and sign your first document. ',
            buttonText: 'TRY FOR FREE'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },
    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _react2['default'].createElement(
            _bodySection2['default'],
            null,
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How do I create a signature to sign documents electronically?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'There are a few ways you or your signers can create a signature.'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Use your finger to draw a signature.'
                    ),
                    ' You can sign documents on any touchscreen device by using your finger or a stylus. This is a nice option since it most closely mimics the style of signing with pen and paper without the need for printing.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Upload an image of your signature.'
                    ),
                    ' Upload or scan a picture of your signature and we\u2019ll turn it into a .png image. It overlays neatly on top of the signature line on your document.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Draw your signature using a mouse.'
                    ),
                    ' Use your mouse to draw a signature using your cursor.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Type in your signature.'
                    ),
                    ' Choose one of our fonts that most closely matches your signature.'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Is it safe to sign documents electronically?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Yep! It\u2019s safe to sign documents electronically. eSignatures have been federally protected since 2000 giving them legs in court. As for security, HelloSign offers bank level protection to ensure that your information is kept safe and secure. You can ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures/',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'learn more about the legality of eSignatures here'
                ),
                ' and ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'https://www.hellosign.com/info/security',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'more about the security provided by HelloSign here.'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What kinds of documents can I sign electronically?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'You can sign all sorts of documents electronically , from offer letters to sales contracts. Here are a few examples of documents you can sign using HelloSign:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'NDAs'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Waivers'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Real estate contracts'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Rental agreements'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Onboarding paperwork'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Vendor contracts'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'And more!'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What does it look like to sign a document electronically?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Signing a document electronically looks a lot like it does when you sign a document using pen and paper.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'If you\u2019re just signing a document electronically, you simply click \u201CInsert Signature\u201D and use any of the 5 ways to create your signature for the document.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'If you\u2019re formatting a document to send out for signature, you\u2019ll need to upload your document and prep it for signature using text or signature fields.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'You can insert your signature into the appropropriate field if you need to sign the document as well.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What else can I do using HelloSign?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'You can use HelloSign to format paperwork online, create templates for frequently used documents, and keep track of your documents using automatic email reminders.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'A few team features that are particularly useful are data validation to protect against signer error and user permissions to keep highly sensitive documents secure.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                _react2['default'].createElement(
                    'a',
                    { href: 'https://www.hellosign.com/info/tour',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'Learn more about what you can do with HelloSign here.'
                )
            )
        );
    },
    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get Started',
            subtitle: 'Start signing your documents electronically! It’s simple to get set up with a free HelloSign account. For higher volume plans (including unlimited documents), visit our pro plan page.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            null,
            this.renderTitleSection(),
            this.renderBodySection(),
            this.renderCTASection()
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/sign-documents-electronically.jsx
 ** module id = 1221
 ** module chunks = 0
 **/